/**
 * Returns a debounced wrapper that only invokes `func` once per `wait` ms of quiet. When `immediate` is
 * true it fires on the leading edge instead of the trailing edge. The wrapper preserves `this`/arguments,
 * so it can be used directly as a jQuery event handler.
 *
 * @param {number} wait
 * @param {boolean} immediate
 * @param {Function} func
 * @returns {Function}
 */
export default function debounce(wait, immediate, func) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
